export default __webpack_public_path__ + "static/media/booking.0673e648.jpg";